module.exports = __webpack_public_path__ + "img/djdc-logo.076ca629.png";